import React, { useState, useEffect } from "react";
import { Col, Label, Row } from "reactstrap";
import { UserListTableData } from "../../../../data/users/UsersList";
import Select from "react-select";
import { dynamicImage } from "../../../../service";
import { Image } from "../../../../AbstractElements";
import { customReactSelectStyles } from "../../../../styles/ReactSelectStyles";
import { useTranslation } from "react-i18next";

// Explicit type for react-select option
interface OptionType {
  value: string;
  label: string;
  image?: string;
}

function AcessRightDropdown() {
  const {t}=useTranslation()
  const [selectedOrg, setSelectedOrg] = useState<OptionType | null>(null);
  const [selectedRole, setSelectedRole] = useState<OptionType | null>(null);
  const [selectedName, setSelectedName] = useState<OptionType | null>(null);

  // Only include users with a valid id
  const validUsers = UserListTableData.filter((u) => u.id);
  console.log(validUsers, "validUsers");

  // 1. Get unique organizations
  const orgOptions: OptionType[] = Array.from(
    new Set(validUsers.map((u) => u.organizationname))
  ).map((org) => {
    // Find a user from this org to get the logo (assuming all users from the same org have the same logo)
    const user = validUsers.find((u) => u.organizationname === org);
    return {
      value: org,
      label: org,
      image: user?.logo, // or use orgLogoMap[org]
    };
  });

  // 2. Get roles for selected org (use 'role' property)
  const roleOptions: OptionType[] = selectedOrg
    ? Array.from(
        new Set(
          validUsers
            .filter((u) => u.organizationname === selectedOrg.value)
            .map((u) => u.role)
        )
      )
        .filter((role) => !!role)
        .map((role) => ({ value: role as string, label: role as string }))
    : [];

  // 3. Get names for selected org+role, include image
  const nameOptions: OptionType[] =
    selectedOrg && selectedRole
      ? validUsers
          .filter(
            (u) =>
              u.organizationname === selectedOrg.value &&
              u.role === selectedRole.value
          )
          .map((u) => ({
            value: u.name || "",
            label: u.name || "",
            image: u.image,
          }))
      : [];

  // Set default values on mount
  useEffect(() => {
    if (!selectedOrg && orgOptions.length > 0) {
      setSelectedOrg(orgOptions[0]);
    }
  }, [orgOptions, selectedOrg]);

  useEffect(() => {
    if (selectedOrg && !selectedRole && roleOptions.length > 0) {
      setSelectedRole(roleOptions[0]);
    }
  }, [selectedOrg, roleOptions, selectedRole]);

  useEffect(() => {
    if (
      selectedOrg &&
      selectedRole &&
      !selectedName &&
      nameOptions.length > 0
    ) {
      setSelectedName(nameOptions[0]);
    }
  }, [selectedOrg, selectedRole, nameOptions, selectedName]);

  // Find the selected name option (with image) for value
  const selectedNameOption = selectedName
    ? nameOptions.find((option) => option.value === selectedName.value) ||
      selectedName
    : null;

  return (
    <Row className="pt-2">
      <Col sm="4" className="mb-3">
        <Label>{t("Organizations")}</Label>
        <Select
          options={orgOptions}
          value={selectedOrg}
          isClearable={true}
          onChange={(option) => {
            setSelectedOrg(option as OptionType);
            setSelectedRole(null);
            setSelectedName(null);
          }}
          placeholder="Select Organization"
          styles={customReactSelectStyles}
          classNamePrefix="select"
          formatOptionLabel={(option) => (
            <div className="d-flex align-items-center">
              {option.image && (
                <Image
                  src={dynamicImage(option.image)}
                  alt={option.label}
                  style={{
                    width: 30,
                    height: 30,
                    borderRadius: "50%",
                    marginRight: 8,
                  }}
                />
              )}
              <span>{option.label}</span>
            </div>
          )}
        />
      </Col>
      <Col sm="4" className="mb-3">
        <Label>{t("User Role")}</Label>
        <Select
          options={roleOptions}
          value={selectedRole}
          isClearable={true}
          onChange={(option) => {
            setSelectedRole(option as OptionType);
            setSelectedName(null);
          }}
          placeholder="Select Role"
          isDisabled={!selectedOrg}
          styles={customReactSelectStyles}
          classNamePrefix="select"
        />
      </Col>
      <Col sm="4" className="mb-3">
        <Label>{t("User Name")}</Label>
        <Select
          options={nameOptions}
          value={selectedNameOption}
          onChange={(option) => setSelectedName(option as OptionType)}
          placeholder="Select Name"
          isDisabled={!selectedRole}
          styles={customReactSelectStyles}
          isClearable={true}
          formatOptionLabel={(option) => (
            <div className="d-flex align-items-center">
              <Image
                src={dynamicImage(option.image)}
                alt={option.label}
                style={{
                  width: 30,
                  height: 30,
                  borderRadius: "50%",
                  marginRight: 8,
                }}
              />
              <span>{option.label}</span>
            </div>
          )}
          classNamePrefix="select"
        />
      </Col>
    </Row>
  );
}

export default AcessRightDropdown;
